import React from 'react'

export interface BaseTableViewProps {
  item: any
}

export const renderAccountNameFieldValue = (accountName: string) =>
  accountName !== '' ? <span>{accountName}</span> : <div style={{ minHeight: 24 }}></div>
